import "slick-carousel";

$(function () {
    $('.slider').slick({
        slidesToShow: 3,
        slidesToScroll: 3,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 80000,
        cssEase: 'linear',
        infinite: true,
        focusOnSelect: false,
        variableWidth: true,
        draggable: false,
        pauseOnHover: false,
        pauseOnFocus: false,
        arrows: false,
        responsive: [
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 6,
                    slidesToScroll: 6,
                }
            }
        ]

    });
})
